// External libraries
import React from 'react';

export const PpwCardIcon = (): React.ReactElement => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="1.5"
      y="4.5"
      width="17"
      height="12"
      rx="2"
      stroke="#fff"
      strokeWidth="1.4"
    />
    <path d="M1.5 8.5h17" stroke="#fff" strokeWidth="1.4" />
    <circle cx="14.5" cy="13" r="1" fill="#fff" />
  </svg>
);
